export default "__VITE_ASSET__18cee0a6__"